import Source from "./From/Source";
import Customer from "./To/Customer";
import Target from "./To/Target";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import Buttons from "./Buttons";
import List from './List';
import Shipping from "./Shipping";
import AccountDate from "./Invoice/Dates/AccountDate";

export default class WriteOffForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props} = componentProps;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                writeoffs={props.writeoffs}
                setCurrentTab={props.setCurrentTab}
                currentTab={props.currentTab}
                setContent={props.setContent}
                parentSetContent={props.parentSetContent}
                editors={props.editors}
                currentEditor={props.currentEditor}
                theme="default"
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-3">
                                <Source {...componentProps} filterFields={["seller","customer"]} />
                            </div>
                            {props.values.preset !== "Expired" ? <Fragment>
                                <div className="col-md-3">
                                    <Customer {...componentProps} label="Partner" />
                                </div>
                                <div className="col-md-3">
                                    <Target {...componentProps} />
                                </div>
                            </Fragment> : null}
                            <AccountDate
                                col="3"
                                {...componentProps}
                                isClearable={true}
                            />
                        </div>
                        {props.values.preset !== "Expired" ? <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div> : null}
                        <Comment {...componentProps} />
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}